import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    login as loginThunk,
    logoutSession,
    refreshToken as refreshTokenThunk,
    selectUser,
    selectIsAuthenticated,
    selectAuthLoading,
    selectAuthError,
    selectRequiresTwoFactor
} from '../features/auth/authSlice';

export const useAuth = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector(selectUser);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const loading = useSelector(selectAuthLoading);
    const error = useSelector(selectAuthError);
    const requiresTwoFactor = useSelector(selectRequiresTwoFactor);

    const handleLogin = (credentials) => dispatch(loginThunk(credentials));

    const handleLogout = () => {
        const request = dispatch(logoutSession());
        request.finally(() => navigate('/login'));
        return request;
    };

    const handleRefreshToken = () => dispatch(refreshTokenThunk());

    return {
        user,
        isAuthenticated,
        loading,
        error,
        requiresTwoFactor,
        login: handleLogin,
        logout: handleLogout,
        refreshToken: handleRefreshToken
    };
};
